<template>
  <div>
    <Header />

    <div class="bg-light">
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">{{ $t("faq.title") }}</h2>
          <a href="#">Accueil</a> <i class="ti ti-angle-right"></i>
          <span>FAQ</span>
        </div>

        <div class="row justify-content-center mt-5">
          <div class="col-lg-6">
            <h2 class="h2-title text-center">{{ $t("faq.title") }}</h2>
            <h3 class="font-bold blue-color text-center">{{ $t("faq.question_prompt") }}</h3>
            <p class="text-center font-16">{{ $t("faq.intro") }}</p>
          </div>
        </div>

        <div class="row mt-3 align-items-center justify-content-center pb-5">
          <div class="col-lg-6">
            <div class="accordion">
              <template v-for="(faq, index) in faqs" :key="index">
                <details>
                  <summary>{{ faq.question }}</summary>
                  <div class="response-content" v-html="faq.reponse"></div>
                </details>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="service-list p-60">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Service />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import Service from "@/components/Service.vue";
  import { useFaqsStore } from "@/stores/faqStore";
  import { useRegisterStore } from "@/stores/register";
  export default {
    components: {
      Header,
      Footer,
      Service,
    },
    data() {
      return {
        faqStore: null,
      };
    },
    computed: {
      faqs() {
        return useFaqsStore()
          .faqs.slice()
          .sort((a, b) => a.position - b.position);
      },
    },
    mounted() {
      this.registerStore = useRegisterStore();
      const role = this.registerStore.user?.role;
      const isClient = role === "client";
      var faqStore = useFaqsStore();
      faqStore.fetchFaqs(isClient);
    },
  };
</script>
